module.exports = __webpack_public_path__ + "img/logo-left3.151c5f28.png";